//* When edit these fields, message will not popup
export const IX_ONE_FIELD = [
  'productname',
  'productdescription',
  'height',
  'width',
  'depth',
  'weight',
  'ecommercefeatures',
  'ecommercegordonfoodservice',
  'ecommercegordonfoodservicebullet1',
  'ecommercegordonfoodservicebullet2',
  'ecommercegordonfoodservicebullet3',
  'ecommercegordonfoodservicebullet4',
  'ecommercegordonfoodservicebullet5',
  'ecommercelongdescriptiona',
  'ecommercelongdescriptionb',
  'ecommercenamea',
  'ecommercenamew',
  'ecommerceproductdescription',
  'ecommerceriteaidproductdescription',
  'ecommerceriteaidproducttitle',
  'ecommercesearchterms',
  'ecommerceshelfdescription',
  'ecommerceshortdescription',
  'itemromancedescription',
  'manufacturernameheader',
  'productflavor',
  'productscent',
  'productstyle',
  // 'vendoritemnumber',
  'tdcproperties.itemromancedescription',
  'tradeitemdescription.tradeitemdescriptioninformation.additionaltradeitemdescription.languagecode',
  'tradeitemdescription.tradeitemdescriptioninformation.additionaltradeitemdescription.value',
  'tradeitemdescription.tradeitemdescriptioninformation.descriptionshort',
  'tradeitemdescription.tradeitemdescriptioninformation.descriptionshort.languagecode',
  'tradeitemdescription.tradeitemdescriptioninformation.descriptionshort.value',
  'tradeitemdescription.tradeitemdescriptioninformation.functionalname.languagecode',
  'tradeitemdescription.tradeitemdescriptioninformation.functionalname.value',
  'tradeitemdescription.tradeitemdescriptioninformation.tradeitemdescription',
  'tradeitemdescription.tradeitemdescriptioninformation.tradeitemdescription.languagecode',
  'tradeitemdescription.tradeitemdescriptioninformation.tradeitemdescription.value',
  'marketinginformation.marketinginformation.tradeitemmarketingmessage',
  'marketinginformation.marketinginformation.tradeitemmarketingmessage.codelistversion',
  'marketinginformation.marketinginformation.tradeitemmarketingmessage.formattingpattern',
  'marketinginformation.marketinginformation.tradeitemmarketingmessage.languagecode',
  'marketinginformation.marketinginformation.tradeitemmarketingmessage.sequencenumber',
  'marketinginformation.marketinginformation.tradeitemmarketingmessage.value',
  'tradeitemdescription.tradeitemdescriptioninformation.brandnameinformation.brandname',
  'tradeitemdescription.tradeitemdescriptioninformation.brandnameinformation.languagespecificbrandname.value',
  'tradeitemdescription.tradeitemdescriptioninformation.brandnameinformation.languagespecificbrandname.languagecode',
];

export const TDC_PROPERTIES = {
  'tdcproperties.case_planogramheight':
    'Case Product Planogram Height in Inches',
  'tdcproperties.ixoneid': 'IX-ONE ID',
  'tdcproperties.status': 'Status',
  'tdcproperties.producttransferring': 'Product Transferring',
  'tdcproperties.transferredtoproduction': 'Transferred to Production',
  'tdcproperties.transferredtoproductiondate': 'Transferred Date',
  'tdcproperties.transferredtoproductionexception': 'Transfer Exception',
  'tdcproperties.transferredtoproductionsuccessful':
    'Transferred to Production Succesfully',
  'tdcproperties.biobasedyn': 'Bio-Based Claim',
  'tdcproperties.ecofisheryyn': 'Eco Fishery Claim',
  'tdcproperties.hasfoodgradeplasticscertifier':
    'Has Food Grade Plastics Certifier',
  'tdcproperties.highpotency': 'High Potency',
  'tdcproperties.liveandactiveculture': 'Live and Active Culture Claim',
  'tdcproperties.nongmoyn': 'Non-GMO Claim',
  'tdcproperties.organicyn': 'Organic Claim',
  'tdcproperties.pacayn': 'PACA Claim',
  'tdcproperties.pasayn': 'PASA Claim',
  'tdcproperties.productisbiodegradable': 'Is Product Biodegradable',
  'tdcproperties.releasenotation': 'Release Notation',
  'tdcproperties.sustainedrelease': 'Sustained Release',
  'tdcproperties.veteransyn': 'Veterans Claim',
  'tdcproperties.waterqualityassociationcertified': 'Water Quality Association',
  'tdcproperties.wercsregistered': 'WERCS Registered',
  'tdcproperties.wfglobalanimalpartnershipratingclaimlevel':
    'Global Animal Partnership Rating Claim Level',
  'tdcproperties.liveandactiveculturecertified':
    'Live And Active Culture Certified',
  'tdcproperties.primarysizetext': 'Size Text Description',
  'tdcproperties.ingredientschina': 'Ingredients Sourced from China',
  'tdcproperties.enlargedtoshowtexture': 'Enlarged to Show Texture',
  'tdcproperties.itemromancedescription': 'Item Romance Description',
  'tdcproperties.qrcode': 'QR Code',
  'tdcproperties.biodegradable': 'Biodegradable Unit Packaging',
  'tdcproperties.bpafreeliner': 'BPA-Free Liner',
  'tdcproperties.bpafreepackaging': 'BPA Free Packaging',
  'tdcproperties.containsbpa': 'Contains BPA',
  'tdcproperties.foodgradeplastic': 'Food Grade Plastic Claim',
  'tdcproperties.foodservicebulkpack': 'FoodService/Bulk Pack',
  'tdcproperties.recycledmaterial': 'Made with Recycled Materials',
  'tdcproperties.recycledmaterialtype': 'Type of Recycling Symbol',
  'tdcproperties.soyink': 'Soy Ink',
  'tdcproperties.catchweightitem': 'Catch Weight Item',
  'tdcproperties.eannumber': 'Product EAN - 13',
  'tdcproperties.grossweight': 'Gross Weight',
  'tdcproperties.tareweight': 'Tare Weight',
  'tdcproperties.recipe1': 'Recipe 1',
  'tdcproperties.recipe2': 'Recipe 2',
  'tdcproperties.recipe3': 'Recipe 3',
  'tdcproperties.recipe4': 'Recipe 4',
  'tdcproperties.recipe5': 'Recipe 5',
  'tdcproperties.alcoholcontentproof': 'Alcohol Content - Proof',
  'tdcproperties.containercolor': 'Redemption Container Color',
  'tdcproperties.containermaterialandsize':
    'Redemption Container Material and Size',
  'tdcproperties.msds': 'MSDS',
  'tdcproperties.sulfitesppm': 'Sulfites PPM',
  'tdcproperties.bottledby': 'Bottled By',
  'tdcproperties.brokensealwarningpresent': 'Broken Seal Warning Present',
  'tdcproperties.codedateexample': 'Date Code Example',
  'tdcproperties.codedateformula': 'Date Code Formula',
  'tdcproperties.codedateposition': 'Date Code Position',
  'tdcproperties.codedatestamp': 'Date Code - Open or Closed',
  'tdcproperties.codedatetype': 'Date Code Type',
  'tdcproperties.containertype': 'Container Type',
  'tdcproperties.countryoforigintext': 'Country Of Origin Text',
  'tdcproperties.distributedby': 'Distributed By',
  'tdcproperties.importedby': 'Imported By',
  'tdcproperties.madein': 'Made In',
  'tdcproperties.manufacturercitypackaging': 'Manufacturer City from Package',
  'tdcproperties.manufacturercodeexample': 'Manufacturer Code Example',
  'tdcproperties.manufacturercodeformula': 'Manufacturer Code Formula',
  'tdcproperties.manufacturercodeposition': 'Manufacturer Code Position',
  'tdcproperties.manufacturercountrypackaging':
    'Manufacturer Country from Package',
  'tdcproperties.manufacturernamepackaging': 'Manufacturer Name from Package',
  'tdcproperties.manufacturerphonenumberpackaging':
    'Manufacturer Phone Number from Package',
  'tdcproperties.manufacturerstatepackaging': 'Manufacturer State from Package',
  'tdcproperties.manufacturerstreetpackaging':
    'Manufacturer Street Address from Package',
  'tdcproperties.manufacturerzipcodepackaging':
    'Manufacturer Zip Code from Package',
  'tdcproperties.merchandisedintray': 'Merchandised In Tray',
  'tdcproperties.packedin': 'Packed In',
  'tdcproperties.peghole': 'Peg Hole/Hanger Present',
  'tdcproperties.perishable': 'Perishable',
  'tdcproperties.processedandpackedin': 'Processed and Packed In',
  'tdcproperties.producedin': 'Produced In',
  'tdcproperties.productof': 'Product Of',
  'tdcproperties.restriction': 'Restriction',
  'tdcproperties.shelflifeafteropening': 'Shelf Life After Opening',
  'tdcproperties.retaincase': 'Retain Case',
  'tdcproperties.retaininner': 'Retain Inner',
  'tdcproperties.retainunit': 'Retain Unit',
  'tdcproperties.stampdate': 'Stamp Date',
  'tdcproperties.cubicinches': 'Cubic Inches',
  'tdcproperties.upc_check_digit': 'UPC Check Digit',
  'tdcproperties.allowedmembers': 'Allowed Members',
  'tdcproperties.restrictedmembers': 'Restricted Members',
  'tdcproperties.allergensancillary': 'Ancillary Information',
  'tdcproperties.processedonequipment': 'Processed/Manufactured in a Facility',
  'tdcproperties.attributesancillary': 'Attributes Ancillary',
  'tdcproperties.calorieclaim': 'Calorie Claims',
  'tdcproperties.contains': 'Contains',
  'tdcproperties.doesnotcontain': 'Does Not Contain',
  'tdcproperties.fatcontent': 'Fat Content Claims',
  'tdcproperties.milktype': 'Milk Types',
  'tdcproperties.phlevel': 'PH Level',
  'tdcproperties.process': 'Non-Certified Claims',
  'tdcproperties.saltcontent': 'Salt or Sodium Claims',
  'tdcproperties.sugarsweetener': 'Sugar and Sweetener Claims',
  'tdcproperties.foodgradeplasticscertifier': 'Food Grade Plastic Certifier',
  'tdcproperties.organiccertifier': 'Organic Certifier',
  'tdcproperties.ingredientbreakout': 'Ingredient Breakout',
  'tdcproperties.ingredientsancillary': 'Ingredients Ancillary',
  'tdcproperties.cookinginstructions': 'Cooking Instructions',
  'tdcproperties.instructionsancillary': 'Ancillary Instructions',
  'tdcproperties.openinginstructions': 'Opening Instructions',
  'tdcproperties.useorfreezeby': 'Use or Freeze by',
  'tdcproperties.copyrighttrademarkregistered':
    'Copyright/Trademark/Registered',
  'tdcproperties.productwarningstatement': 'Product Warning Statement',
  'tdcproperties.questionorcommentsstatement': 'Question or Comments Statement',
  'tdcproperties.slogan': 'Slogan',
  'tdcproperties.socialmedia': 'Social Media',
  'tdcproperties.socialmediaaddresses': 'Social Media Addresses',
  'tdcproperties.website': 'Website',
  'tdcproperties.ancillarypackaginginformation':
    'Ancillary Packaging Information',
  'tdcproperties.packagingdescriptors': 'Packaging Descriptors',
  'tdcproperties.recyclestatement': 'Recycling Advice',
  'tdcproperties.ancillaryinformation': 'Ancillary Product Information',
  'tdcproperties.redemptionvalues': 'Redemption Values',
  'tdcproperties.rulesandregulationsancillary': 'Rules & Regulations Ancillary',
  'tdcproperties.transportationrestrictions': 'Transportation Restrictions',
  'tdcproperties.warninglabels': 'Warning Labels',
  'tdcproperties.manufacturercodesupplementaryinformation':
    'Supplementary Manufacturer Code Information',
  'tdcproperties.manufactureremailaddressfrompackage':
    'Manufacturer Email Address from Package',
  'tdcproperties.supplementarycodedateinformation':
    'Supplemental Date / Timestamp',
  'tdcproperties.supplychainancillary': 'Ancillary Supply Chain Information',
  'tdcproperties.contractmanufacturer': 'Contract Manufacturer',
  'tdcproperties.italcertifiedsealclaim': 'ITAL CERTIFIED SEAL Claim',
  'tdcproperties.italconscioussealclaim': 'ITAL CONSCIOUS SEAL Claim',
  'tdcproperties.italsacramentsealclaim': 'ITAL SACRAMENT SEAL Claim',
  'tdcproperties.beebetterclaim': 'Bee Friendly Claim',
  'tdcproperties.nongmocertificationbyearthkosherclaim':
    'Non-GMO Certification By Earth-Kosher Claim',
  'tdcproperties.glyphosateresiduefreeclaim': 'Glyphosate Residue Free Claim',
  'tdcproperties.sellable': 'Is Product Sellable',
  'tdcproperties.originalpackagelevel': 'Original Package Level',
  'tdcproperties.nongmogecertifiedbynsf': 'Non-GMO/GE Certified By NSF',
  'tdcproperties.nongmocertificationbyearthkosher':
    'Non-GMO Certification By Earth-Kosher',
  'tdcproperties.gmostatement': 'GMO Statement',
  'tdcproperties.newyorkstategrowncertifierclaim':
    'New York State Grown & Certified Claim',
  'tdcproperties.nongmogmostatement': 'Non-GMO/GMO Statement',
  'tdcproperties.rbghbststatement': 'RBGH/BST Statement',
  'tdcproperties.vegetablebasedink': 'Vegetable Based Ink',
  'tdcproperties.regenerativeorganicclaim': 'Regenerative Organic Claim',
  'tdcproperties.californiaprop65compliant': 'California Prop 65 Compliant',
  'tdcproperties.processedmanufacturedinfacilitystatement':
    'Processed / Manufactured in a Facility Statement',
  'tdcproperties.infacilityonequipmentincluding':
    'In a Facility / On Equipment including',
  'tdcproperties.infacilityonequipmentstatement':
    'In a Facility / On equipment statement',
  'tdcproperties.patentinformation': 'Patent Information',
  'tdcproperties.brokensealwarningstatement': 'Broken Seal Warning Statement',
  'tdcproperties.manufacturedforanddistributedby':
    'Manufactured For And Distributed By',
  'tdcproperties.ixonecertificationlevel': 'IX-ONE Certification Level',
  'tdcproperties.ixonecoredate': 'Ix-One Core Date',
  'tdcproperties.alcoholbyvolumestatement': 'Alcohol % By Volume Statement',
  'tdcproperties.alcoholproofstatement': 'Alcohol Proof Statement',
  'tdcproperties.importedbottledby': 'Imported & Bottled By',
  'tdcproperties.producedby': 'Produced By',
  'tdcproperties.producedbottledby': 'Produced & Bottled By',
  'tdcproperties.flavortastingnotes': 'Flavor/Tasting Notes',
  'tdcproperties.significantsource_p': 'Good/Contains/Provides',
  'tdcproperties.excellentsource_p': 'High/Rich In/Excellent Source',
  'tdcproperties.notsignificantsource_p': 'Not Significant Source',
  'tdcproperties.primarynutritionalitemancillary_p':
    'Primary Nutritional Item Ancillary',
  'tdcproperties.highpressurecertifiedclaim': 'High Pressure Certified Claim',
  'tdcproperties.secondaryexcellentsource_p': 'Secondary Excellent Source',
  'tdcproperties.secondarynutritionalitemancillary_p':
    'Secondary Nutritional Item Ancillary',
  'tdcproperties.availablelanguages': 'Available Languages',
  'tdcproperties.mrmstatus': 'MRM Status',
  'tdcproperties.producteta': 'Product ETA',
  'tdcproperties.mrmcomment': 'MRM Comment',
  'tdcproperties.californiaprop65warningsymbolpresent':
    'California Prop 65 Warning Symbol Present',
  'tdcproperties.californiaprop65warningstatement':
    'California Prop 65 Warning Statement',
  'tdcproperties.publishfailmissingfields': 'Publish Fail Missing Fields',
  'tdcproperties.containerandmaterialtypes': 'Container And Material Types',
  'tdcproperties.inktypes': 'Ink Type',
  'tdcproperties.excisetaxes': 'Excise Taxes',
  'tdcproperties.expectedcost': 'Expected Cost',
  'tdcproperties.actualcost': 'Actual Cost',
  'tdcproperties.lostworkcost': 'Lost Work Cost',
  'tdcproperties.aplupload': 'APL/Upload',
  'tdcproperties.ispaid': 'Is Paid',
  'tdcproperties.isshippingdocumentprinted': 'Is Shipping Document Printed',
  'tdcproperties.totaldownloads': 'Total Downloads',
  'tdcproperties.totalviews': 'Total Views',
  'tdcproperties.memberimages': 'Member Images',
  'tdcproperties.productdiscontinued': 'Product Discontinued',
  'tdcproperties.receivedin': 'Received In',
  'tdcproperties.datereceived': 'Date Received',
  'tdcproperties.completelistingingredient': 'Complete Listing Of Ingredients',
  'tdcproperties.ingredientssourcedfromchina': 'Ingredients Source From China',
  'tdcproperties.sustainablepackagingfeatures':
    'Sustainable Packaging Features',
  'tdcproperties.ncgparentcompanyname': 'Parent Company',
  'tdcproperties.ncgreviewstatus': 'NCG Review Status',
  'tdcproperties.ncgreviewimportdate': 'NCG Review Import Date',
  'tdcproperties.ncgreviewsubmitdate': 'NCG Review Submit Date',
  'tdcproperties.nonirradiatedingredients': 'Non-Irradiated Ingredients',
  'tdcproperties.personalcareitemcontains': 'Personal Care Item Contains',
  'tdcproperties.animalproductcontains': 'Animal Product Contains',
  'tdcproperties.mrmstatusdate': 'MRM Status Date',
  'tdcproperties.productstatusdate': 'Product Status Date',
  'tdcproperties.note': 'Note',
  'tdcproperties.bronzedisposition': 'Bronze Disposition',
  'tdcproperties.bronzedispositionsubmitdate': 'Bronze Disposition Submit Date',
  'tdcproperties.bronzereportprocessing': 'Bronze Report Processing',
  'tdcproperties.bronzereportcompleted': 'Bronze Report Completed',
  'tdcproperties.dateaddeddisplayexchange': 'Date Added Display Exchange',
  'tdcproperties.billingentity': 'Billing Entity',
  'tdcproperties.productpublishas': 'Product Publish As',
  'tdcproperties.bioengineeredyn': 'Bioengineered Claim',
  'tdcproperties.bioengineeredstatement': 'Bioengineered Ingredients Statement',
  'tdcproperties.bioengineeredtype': 'Bioengineered Type',
  'tdcproperties.productworkflowstatus': 'Product Workflow Status',
  'tdcproperties.magicnumber': 'Magic Number',
  'tdcproperties.planogramheight': 'Product Planogram Height in Inches',
  'tdcproperties.planogramdepth': 'Product Planogram Depth in Inches',
  'tdcproperties.planogramwidth': 'Product Planogram Width in Inches',
  'tdcproperties.thccontentpercent': 'THC Content / Percent',
  'tdcproperties.supplementingredientstatement':
    'Supplement Ingredient Statement',
  'tdcproperties.imagevendorname': 'Image Vendor Name',
  'tdcproperties.availableforcapture': 'Available For Capture',
  'tdcproperties.bronzeskipcheckout': 'Bronze Skip Checkout',
  'tdcproperties.gdsnprovidednutclaim': 'GDSN Provided Nutritional Claims',
  'tdcproperties.eli_code': 'ELI Code',
  'tdcproperties.lastrequestupcitemdbdate': 'Last Request Upc Item Db Date',
  'tdcproperties.lastupdateddate': 'Last Updated Date',
  'tdcproperties.haspanel': 'Has Panel',
  'tdcproperties.hassupplementpanel': 'Has Supplement Panel',
  'tdcproperties.hasaminoacidpanel': 'Has Amino Acid Panel',
  'tdcproperties.hasnutritionpanel': 'Has Nutrition Panel',
  'tdcproperties.returnproducttomanufacturer': 'Return Product to Manufacturer',
  'tdcproperties.caseaseach': 'Caseas Each',
  'tdcproperties.productisalsocase': 'Is Product Also Case',
  'tdcproperties.heightinpixels': 'Height In Pixels',
  'tdcproperties.widthinpixels': 'Width In Pixels',
  'tdcproperties.depthinpixels': 'Depth In Pixels',
  'tdcproperties.ratioheightwidthpixels': 'Ratio Height Width Pixels',
  'tdcproperties.ratioheightdepthpixels': 'Ratio Height Depth Pixels',
  'tdcproperties.ratiodepthwidthpixels': 'Ratio Depth Width Pixels',
  'tdcproperties.needreviewdimension': 'Need Review Dimension',
  'tdcproperties.fairtradestatement': 'Fair Trade Statement',
  'tdcproperties.plu': 'PLU',
  'tdcproperties._donotbill': 'Do Not Bill',
  'tdcproperties._donotbillreason': 'Do Not Bill Reason',
  'tdcproperties.lastlistmanagementupdated': 'Last List Management Updated',
  'tdcproperties.paiddate': 'Paid Date',
  'tdcproperties.paidreason': 'Paid Reason',
  'tdcproperties.governmentwarning': 'Government Warning',
  'tdcproperties.sulfitesppc': 'Sulfies PPM',
  'tdcproperties.winecategory': 'Wine Category',
  'tdcproperties.winevarietal': 'Wine Varietal',
  'tdcproperties.winesweetness': 'Wine Sweetness',
  'tdcproperties.winecorktype': 'Wine Cork Type',
  'tdcproperties.winepairswellwith': 'Wine Pairs Well With',
  'tdcproperties.winebody': 'Wine Body',
  'tdcproperties.beerbrewery': 'Beer Brewery',
  'tdcproperties.beercategory': 'Beer Category',
  'tdcproperties.ibus': 'IBUs',
  'tdcproperties.beertaste': 'Beer Taste',
  'tdcproperties.beerbody': 'Beer Body',
  'tdcproperties.beerfinalgravity': 'Beer Final Gravity',
  'tdcproperties.bwsproducedby': 'BWS Produced By',
  'tdcproperties.bwsdistributedby': 'BWS Distributed By',
  'tdcproperties.bwsimportedby': 'BWS Imported By',
  'tdcproperties.finishedandbottledin': 'Finished and Bottled In',
  'tdcproperties.transferringdate': 'Transferring Date',
  'tdcproperties.productrenewaldisposition': 'Product Renewal Disposition',
  'tdcproperties.productrenewalconfirmeddate': 'Product Renewal Confirmed Date',
  'tdcproperties.ncgshipped': 'NCG Shipped',
  'tdcproperties.ncgshippeddate': 'NCG Shipped Date',
  'tdcproperties.ncgcontactname': 'NCG Contact Name',
  'tdcproperties.ncgcontactemail': 'NCG Contact Email',
  'tdcproperties.ncgcontactphone': 'NCG Contact Phone',
  'tdcproperties.bwsbottledby': 'BWS Bottled By',
  'tdcproperties.distilledby': 'Distilled By',
  'tdcproperties.deletedreason': 'Deleted Reason',
  'tdcproperties.businessownermanufactureryn':
    'Business Owner / Manufacturer Certified Claim',
  'tdcproperties.mergefrom': 'Merge From',
  'tdcproperties.memberdiscontinued': 'Member Discontinued',
  'tdcproperties.memberdiscontinueddate': 'Member Discontinued Date ',
  'tdcproperties._notforretailsale_upc12': 'Not For Retail Sale UPC12',
  'tdcproperties.isdeleteddiscontinuedproduct':
    'Is Deleted Discontinued Product',
  'tdcproperties.originalstatus': 'Original Status',
  'tdcproperties.usdastatement': 'USDA Statement',
  'tdcproperties.stateregioncertification': 'State Region Certification',
  'tdcproperties.grade': 'Grade',
  'tdcproperties.archivedate': 'Archive Date',
  'tdcproperties.damagenote': 'Damage Note',
  'tdcproperties.damageapproved': 'Damage Approved',
  'tdcproperties.capturefee': 'Capture Fee',
  'tdcproperties.nonfoodproduct': 'Non-Food Product',
  'tdcproperties.segmentcode': 'Segment Code',
  'tdcproperties.segmentdescription': 'Segment Description',
  'tdcproperties.familycode': 'Family Code',
  'tdcproperties.familydescription': 'Family Description',
  'tdcproperties.classcode': 'Class Code',
  'tdcproperties.classdescription': 'Class Description',
  'tdcproperties.brickcodedescription': 'Brick Code Description',
  'tdcproperties.innerpack_qrcode': 'Inner-Pack QR Code',
  'tdcproperties.innerpack_biodegradable':
    'Inner-Pack Biodegradable Unit Packaging',
  'tdcproperties.innerpack_bpafreeliner': 'Inner-Pack BPA-Free Liner',
  'tdcproperties.innerpack_bpafreepackaging': 'Inner-Pack BPA Free Packaging',
  'tdcproperties.innerpack_foodservicebulkpack':
    'Inner-Pack FoodService/Bulk Pack',
  'tdcproperties.innerpack_recycledmaterial':
    'Inner-Pack Made with Recycled Materials',
  'tdcproperties.innerpack_recycledmaterialtype':
    'Inner-Pack Type of Recycling Symbol',
  'tdcproperties.innerpack_soyink': 'Inner-Pack Soy Ink',
  'tdcproperties.innerpack_eannumber': 'Inner-Pack Product EAN - 13',
  'tdcproperties.innerpack_sellable': 'Is Inner-Pack Sellable',
  'tdcproperties.innerpack_codedateexample': 'Inner-Pack Date Code Example',
  'tdcproperties.innerpack_codedateformula': 'Inner-Pack Date Code Formula',
  'tdcproperties.innerpack_codedateposition': 'Inner-Pack Date Code Position',
  'tdcproperties.innerpack_codedatestamp':
    'Inner-Pack Date Code - Open or Closed',
  'tdcproperties.innerpack_codedatetype': 'Inner-Pack Date Code Type',
  'tdcproperties.innerpack_containertype': 'Inner-Pack Container Type',
  'tdcproperties.innerpack_manufacturercodeexample':
    'Inner-Pack Manufacturer Code Example',
  'tdcproperties.innerpack_manufacturercodeformula':
    'Inner-Pack Manufacturer Code Formula',
  'tdcproperties.innerpack_manufacturercodeposition':
    'Inner-Pack Manufacturer Code Position',
  'tdcproperties.innerpack_copyrighttrademarkregistered':
    'Inner-Pack Copyright/Trademark/Registered',
  'tdcproperties.innerpack_socialmedia': 'Inner-Pack Social Media',
  'tdcproperties.innerpack_website': 'Inner-Pack Website',
  'tdcproperties.innerpack_ancillarypackaginginformation':
    'Inner-Pack Ancillary Packaging Information',
  'tdcproperties.innerpack_corrugateinformation':
    'Inner-Pack Corrugate Information',
  'tdcproperties.innerpack_recyclestatement': 'Inner-Pack Recycling Advice',
  'tdcproperties.innerpack_manufacturercodesupplementaryinformation':
    'Inner-Pack Supplementary Manufacturer Code Information',
  'tdcproperties.innerpack_supplementarycodedateinformation':
    'Inner-Pack Supplemental Date / Timestamp',
  'tdcproperties.innerpack_supplychainancillary':
    'Inner-Pack Ancillary Supply Chain Information',
  'tdcproperties.innerpack_vegetablebasedink': 'Inner-Pack Vegetable Based Ink',
  'tdcproperties.innerpack_boxcertification': 'Inner-Pack Box Certification',
  'tdcproperties.innerpack_bursttest': 'Inner-Pack Burst Test',
  'tdcproperties.innerpack_boxdoublewall': 'Inner-Pack Box Double-wall',
  'tdcproperties.innerpack_edgecrushtest': 'Inner-Pack Edge Crush Test',
  'tdcproperties.innerpack_grosswtlimit': 'Inner-Pack Gross Weight Limit',
  'tdcproperties.innerpack_mincombwtfacings':
    'Inner-Pack Min Comb Weight Facings',
  'tdcproperties.innerpack_boxsinglewall': 'Is Inner-Pack Box Single-wall',
  'tdcproperties.innerpack_sizelimit': 'Inner-Pack Size Limit',
  'tdcproperties.innerpack_boxmanufactureraddress':
    'Inner-Pack Box Manufacturer Address',
  'tdcproperties.innerpack_manufacturedforanddistributedby':
    'Inner-Pack Manufactured For And Distributed By',
  'tdcproperties.innerpack_contains': 'Inner-Pack Contains',
  'tdcproperties.innerpack_doesnotcontain': 'Inner-Pack Does Not Contain',
  'tdcproperties.innerpack_alcoholbyvolumestatement':
    'Inner-Pack Alcohol % By Volume Statement',
  'tdcproperties.innerpack_alcoholproofstatement':
    'Inner-Pack Alcohol Proof Statement',
  'tdcproperties.innerpack_importedbottledby':
    'Inner-Pack Imported & Bottled By',
  'tdcproperties.innerpack_producedby': 'Inner-Pack Produced By',
  'tdcproperties.innerpack_producedbottledby':
    'Inner-Pack Produced & Bottled By',
  'tdcproperties.innerpack_vintageyear': 'Inner-Pack Vintage Year',
  'tdcproperties.innerpack_flavortastingnotes':
    'Inner-Pack Flavor/Tasting Notes',
  'tdcproperties.innerpack_winery': 'Inner-Pack Winery',
  'tdcproperties.innerpack_brewery': 'Inner-Pack Brewery',
  'tdcproperties.innerpack_californiaprop65warningsymbolpresent':
    'Inner-Pack California Prop 65 Warning Symbol Present',
  'tdcproperties.innerpack_californiaprop65warningstatement':
    'Inner-Pack California Prop 65 Warning Statement',
  'tdcproperties.innerpack_nocodepresent': 'Inner-Pack No Code Present',
  'tdcproperties.innerpack_containerandmaterialtypes':
    'Inner-Pack Container And Material Types',
  'tdcproperties.innerpack_inktypes': 'Inner-Pack Ink Type',
  'tdcproperties.innerpack_innerpackidentifier': 'Inner-Pack Identifier',
  'tdcproperties.innerpack_innerpack_note': 'Inner-Pack Note',
  'tdcproperties.innerpack_oldinnerpackidentifier': 'Old Inner-Pack Identifier',
  'tdcproperties.innerpack_planogramheight':
    'Inner-Pack Product Planogram Height in Inches',
  'tdcproperties.innerpack_planogramdepth':
    'Inner-Pack Product Planogram Depth in Inches',
  'tdcproperties.innerpack_planogramwidth':
    'Inner-Pack Product Planogram Width in Inches',
  'tdcproperties.innerpack_ingredientschina':
    'Inner-Pack Ingredients Sourced from China',
  'tdcproperties.innerpack_ingredientbreakout':
    'Inner-Pack Ingredient Breakout',
  'tdcproperties.innerpack_ingredientsancillary':
    'Inner-Pack Ingredients Information',
  'tdcproperties.innerpack_cookinginstructions':
    'Inner-Pack Cooking Instructions',
  'tdcproperties.innerpack_instructionsancillary':
    'Inner-Pack Ancillary Instructions',
  'tdcproperties.innerpack_openinginstructions':
    'Inner-Pack Opening Instructions',
  'tdcproperties.innerpack_heightinpixels': 'Inner-Pack Height In Pixels',
  'tdcproperties.innerpack_widthinpixels': 'Inner-Pack Width In Pixels',
  'tdcproperties.innerpack_depthinpixels': 'Inner-Pack Depth In Pixels',
  'tdcproperties.innerpack_ratioheightwidthpixels':
    'Inner-Pack Ratio Height Width Pixels',
  'tdcproperties.innerpack_ratioheightdepthpixels':
    'Inner-Pack Ratio Height Depth Pixels',
  'tdcproperties.innerpack_ratiodepthwidthpixels':
    'Inner-Pack Ratio Depth Width Pixels',
  'tdcproperties.innerpack_needreviewdimension':
    'Inner-Pack Need Review Dimension',
  'tdcproperties.innerpack_lastlistmanagementupdated':
    'Inner-Pack Last List Management Updated',
  'tdcproperties.innerpack_alcoholproof': 'Inner-Pack Alcohol Proof',
  'tdcproperties.innerpack_percentalcoholbyvolume':
    'Inner-Pack % Alcohol By Volume',
  'tdcproperties.innerpack_governmentwarning': 'Inner-Pack Government Warning',
  'tdcproperties.innerpack_distilledin': 'Inner-Pack Distilled In',
  'tdcproperties.innerpack_distilledfrom': 'Inner-Pack Distilled From',
  'tdcproperties.innerpack_sulfitesppc': 'Inner-Pack Sulfies PPM',
  'tdcproperties.innerpack_winecategory': 'Inner-Pack Wine Category',
  'tdcproperties.innerpack_winevarietal': 'Inner-Pack Wine Varietal',
  'tdcproperties.innerpack_winesweetness': 'Inner-Pack Wine Sweetness',
  'tdcproperties.innerpack_wineregion': 'Inner-Pack Wine Region',
  'tdcproperties.innerpack_winecorktype': 'Inner-Pack Wine Cork Type',
  'tdcproperties.innerpack_winepairswellwith':
    'Inner-Pack Wine Pairs Well With',
  'tdcproperties.innerpack_winecomplements': 'Inner-Pack Wine Complements',
  'tdcproperties.innerpack_wineyear': 'Inner-Pack Wine Year',
  'tdcproperties.innerpack_winevintage': 'Inner-Pack Vintage',
  'tdcproperties.innerpack_winetaste': 'Inner-Pack Wine Taste',
  'tdcproperties.innerpack_winebody': 'Inner-Pack Wine Body',
  'tdcproperties.innerpack_winecharacter': 'Inner-Pack Wine Character',
  'tdcproperties.innerpack_spiritsyearsaged': 'Inner-Pack Spirits Years Aged',
  'tdcproperties.innerpack_spiritsbarreltype': 'Inner-Pack Spirits Barrel Type',
  'tdcproperties.innerpack_spiritsflavor': 'Inner-Pack Spirits Flavor',
  'tdcproperties.innerpack_spiritscategory': 'Inner-Pack Spirits Category',
  'tdcproperties.innerpack_spiritssubcategory':
    'Inner-Pack Spirits Sub Category',
  'tdcproperties.innerpack_spiritsstyle': 'Inner-Pack Spirits Style',
  'tdcproperties.innerpack_spiritsregion': 'Inner-Pack Spirits Region',
  'tdcproperties.innerpack_spiritstaste': 'Inner-Pack Spirits Taste',
  'tdcproperties.innerpack_beerbrewery': 'Inner-Pack Beer Brewery',
  'tdcproperties.innerpack_beerregion': 'Inner-Pack Beer Region',
  'tdcproperties.innerpack_beercategory': 'Inner-Pack Beer Category',
  'tdcproperties.innerpack_ibus': 'Inner-Pack IBUs',
  'tdcproperties.innerpack_beerstyle': 'Inner-Pack Beer Style',
  'tdcproperties.innerpack_beertaste': 'Inner-Pack Beer Taste',
  'tdcproperties.innerpack_beerbody': 'Inner-Pack Beer Body',
  'tdcproperties.innerpack_beerfinalgravity': 'Inner-Pack Beer Final Gravity',
  'tdcproperties.innerpack_bwsproducedby': 'Inner-Pack BWS Produced By',
  'tdcproperties.innerpack_bwsdistributedby': 'Inner-Pack BWS Distributed By',
  'tdcproperties.innerpack_bwsimportedby': 'Inner-Pack BWS Imported By',
  'tdcproperties.innerpack_finishedandbottledin':
    'Inner-Pack Finished and Bottled In',
  'tdcproperties.innerpack_wineorigin': 'Inner-Pack Wine Origin',
  'tdcproperties.innerpack_bwsbottledby': 'Inner-Pack BWS Bottled By',
  'tdcproperties.innerpack_distilledby': 'Inner-Pack Distilled By',
  'tdcproperties.case_qrcode': 'Case QR Code',
  'tdcproperties.case_boxcertification': 'Case Box Certification',
  'tdcproperties.case_boxdoublewall': 'Case Box Double-wall',
  'tdcproperties.case_boxmanufacturer': 'Case Box Manufacturer',
  'tdcproperties.case_boxmanufacturercity': 'Case Box Manufacturer City',
  'tdcproperties.case_boxmanufacturerfaxnumber':
    'Case Box Manufacturer FaxNumber',
  'tdcproperties.case_boxmanufacturerstate': 'Case Box Manufacturer State',
  'tdcproperties.case_boxmanufacturerstreet': 'Case Box Manufacturer Street',
  'tdcproperties.case_boxmanufacturertelephonenumber':
    'Case Box Manufacturer Telephone Number',
  'tdcproperties.case_boxmanufacturerzip': 'Case Box Manufacturer Zip',
  'tdcproperties.case_bpafreeliner': 'Case BPA-Free Liner',
  'tdcproperties.case_burstingtest': 'Case Bursting Test',
  'tdcproperties.case_edgecrushtest': 'Case Edge Crush Test',
  'tdcproperties.case_foodservicebulkpack': 'Case FoodService/Bulk Pack',
  'tdcproperties.case_mincombwtfacings': 'Case Min Comb Weight Facings',
  'tdcproperties.case_packagedondatecode': 'Case Packaged On Date Code',
  'tdcproperties.case_recycledmaterialtype': 'Case Type of Recycling Symbol',
  'tdcproperties.case_sizelimit': 'Case Size Limit',
  'tdcproperties.case_soyink': 'Case Soy Ink',
  'tdcproperties.case_eannumber': 'Case Product EAN - 13',
  'tdcproperties.case_sellable': 'Is Case Sellable',
  'tdcproperties.case_casesperpallet': 'Cases Per Pallet',
  'tdcproperties.case_codedateexample': 'Case Date Code Example',
  'tdcproperties.case_codedateformula': 'Case Date Code Formula',
  'tdcproperties.case_codedateposition': 'Case Date Code Position',
  'tdcproperties.case_codedatestamp': 'Case Date Code - Open or Closed',
  'tdcproperties.case_codedatetype': 'Case Date Code Type',
  'tdcproperties.case_containertype': 'Case Container Type',
  'tdcproperties.case_manufacturercodeexample':
    'Case Manufacturer Code Example',
  'tdcproperties.case_manufacturercodeformula':
    'Case Manufacturer Code Formula',
  'tdcproperties.case_temperaturerangehigh': 'Case Temperature Range High',
  'tdcproperties.case_temperaturerangelow': 'Case Temperature Range Low',
  'tdcproperties.case_copyrighttrademarkregistered':
    'Case Copyright/Trademark/Registered',
  'tdcproperties.case_socialmedia': 'Case Social Media',
  'tdcproperties.case_website': 'Case Website',
  'tdcproperties.case_ancillarypackaginginformation':
    'Case Ancillary Packaging Information',
  'tdcproperties.case_boxmanufacturerwebsite': 'Case Box Manufacturer Website',
  'tdcproperties.case_recyclestatement': 'Case Recycling Advice',
  'tdcproperties.case_manufacturercodesupplementaryinformation':
    'Case Supplementary Manufacturer Code Information',
  'tdcproperties.case_supplementarycodedateinformation':
    'Case Supplemental Date / Timestamp',
  'tdcproperties.case_supplychainancillary':
    'Case Ancillary Supply Chain Information',
  'tdcproperties.case_vegetablebasedink': 'Case Vegetable Based Ink',
  'tdcproperties.case_boxmanufactureraddress': 'Case Box Manufacturer Address',
  'tdcproperties.case_manufacturedforanddistributedby':
    'Case Manufactured For And Distributed By',
  'tdcproperties.case_alcoholbyvolumestatement':
    'Case Alcohol % By Volume Statement',
  'tdcproperties.case_alcoholproofstatement': 'Case Alcohol Proof Statement',
  'tdcproperties.case_importedbottledby': 'Case Imported & Bottled By',
  'tdcproperties.case_producedby': 'Case Produced By',
  'tdcproperties.case_producedbottledby': 'Case Produced & Bottled By',
  'tdcproperties.case_vintageyear': 'Case Vintage Year',
  'tdcproperties.case_flavortastingnotes': 'Case Flavor/Tasting Notes',
  'tdcproperties.case_winery': 'Case Winery',
  'tdcproperties.case_brewery': 'Case Brewery',
  'tdcproperties.case_californiaprop65warningsymbolpresent':
    'Case California Prop 65 Warning Symbol Present',
  'tdcproperties.case_californiaprop65warningstatement':
    'Case California Prop 65 Warning Statement',
  'tdcproperties.case_nocodepresent': 'Case No Code Present',
  'tdcproperties.case_inktypes': 'Case Ink Type',
  'tdcproperties.case_caseidentifier': 'Case Identifier',
  'tdcproperties.case_note': 'Case Note',
  'tdcproperties.case_oldcaseidentifier': 'Old Case Identifier',
  'tdcproperties.case_transportationrestrictions':
    'Case Transportation Restrictions',
  'tdcproperties.case_ingredientschina': 'Case Ingredients Sourced from China',
  'tdcproperties.case_ingredientbreakout': 'Case Ingredient Breakout',
  'tdcproperties.case_ingredientsancillary': 'Case Ingredients Ancillary',
  'tdcproperties.case_cookinginstructions': 'Case Cooking Instructions',
  'tdcproperties.case_instructionsancillary': 'Case Ancillary Instructions',
  'tdcproperties.case_openinginstructions': 'Case Opening Instructions',
  'tdcproperties.case_heightinpixels': 'Case Height In Pixels',
  'tdcproperties.case_widthinpixels': 'Case Width In Pixels',
  'tdcproperties.case_depthinpixels': 'Case Depth In Pixels',
  'tdcproperties.case_ratioheightwidthpixels': 'Case Ratio Height Width Pixels',
  'tdcproperties.case_ratioheightdepthpixels': 'Case Ratio Height Depth Pixels',
  'tdcproperties.case_ratiodepthwidthpixels': 'Case Ratio Depth Width Pixels',
  'tdcproperties.case_needreviewdimension': 'Case Need Review Dimension',
  'tdcproperties.case_lastlistmanagementupdated':
    'Case Last List Management Updated',
  'tdcproperties.case_alcoholproof': 'Case Alcohol Proof',
  'tdcproperties.case_percentalcoholbyvolume': 'Case % Alcohol By Volume',
  'tdcproperties.case_governmentwarning': 'Case Government Warning',
  'tdcproperties.case_distilledin': 'Case Distilled In',
  'tdcproperties.case_distilledfrom': 'Case Distilled From',
  'tdcproperties.case_sulfitesppc': 'Case Sulfites PPM',
  'tdcproperties.case_winecategory': 'Case Wine Category',
  'tdcproperties.case_winevarietal': 'Case Wine Varietal',
  'tdcproperties.case_winesweetness': 'Case Wine Sweetness',
  'tdcproperties.case_wineregion': 'Case Wine Region',
  'tdcproperties.case_winecorktype': 'Case Wine Cork Type',
  'tdcproperties.case_winepairswellwith': 'Case Wine Pairs Well With',
  'tdcproperties.case_winecomplements': 'Case Wine Complements',
  'tdcproperties.case_wineyear': 'Case Wine Year',
  'tdcproperties.case_winevintage': 'Case Vintage',
  'tdcproperties.case_winetaste': 'Case Wine Taste',
  'tdcproperties.case_winebody': 'Case Wine Body',
  'tdcproperties.case_winecharacter': 'Case Wine Character',
  'tdcproperties.case_spiritsyearsaged': 'Case Spirits Years Aged',
  'tdcproperties.case_spiritsbarreltype': 'Case Spirits Barrel Type',
  'tdcproperties.case_spiritsflavor': 'Case Spirits Flavor',
  'tdcproperties.case_spiritscategory': 'Case Spirits Category',
  'tdcproperties.case_spiritssubcategory': 'Case Spirits Sub Category',
  'tdcproperties.case_spiritsstyle': 'Case Spirits Style',
  'tdcproperties.case_spiritsregion': 'Case Spirits Region',
  'tdcproperties.case_spiritstaste': 'Case Spirits Taste',
  'tdcproperties.case_beerbrewery': 'Case Beer Brewery',
  'tdcproperties.case_beerregion': 'Case Beer Region',
  'tdcproperties.case_beercategory': 'Case Beer Category',
  'tdcproperties.case_ibus': 'Case IBUs',
  'tdcproperties.case_beerstyle': 'Case Beer Style',
  'tdcproperties.case_beertaste': 'Case Beer Taste',
  'tdcproperties.case_beerbody': 'Case Beer Body',
  'tdcproperties.case_beerfinalgravity': 'Case Beer Final Gravity',
  'tdcproperties.case_bwsproducedby': 'Case BWS Produced By',
  'tdcproperties.case_bwsdistributedby': 'Case BWS Distributed By',
  'tdcproperties.case_bwsimportedby': 'Case BWS Imported By',
  'tdcproperties.case_finishedandbottledin': 'Case Finished and Bottled In',
  'tdcproperties.case_wineorigin': 'Case Wine Origin',
  'tdcproperties.case_shippingtemperaturerangehigh':
    'Case Shipping Temperature Range High',
  'tdcproperties.case_shippingtemperaturerangelow':
    'Case Shipping Temperature Range Low',
  'tdcproperties.case_bwsbottledby': 'Case BWS Bottled By',
  'tdcproperties.case_distilledby': 'Case Distilled By',
  'tdcproperties.case_grosswtlimit': 'Case Gross Weight Limit',
  'tdcproperties.unit_krogerclasscode': 'Kroger Class Code',
  'tdcproperties.unit_minimumshelflife': 'Minimum Shelf Life',
  'tdcproperties.unit_maximumshelflife': 'Maximum Shelf Life',
  'tdcproperties.unit_minimumtransporttemp': 'Minimum Transport Temp',
  'tdcproperties.unit_maximumtransporttemp': 'Maximum Transport Temp',
  'tdcproperties.unit_minimumstoragehandlingtemp':
    'Minimum Storage/Handling Temp',
  'tdcproperties.unit_maximumstoragehandlingtemp':
    'Maximum Storage/Handling Temp',
  'tdcproperties.unit_tie': 'Tie',
  'tdcproperties.unit_high': 'High',
  'tdcproperties.case_krogerclasscode': 'Case Kroger Class Code',
  'tdcproperties.case_minimumshelflife': 'Case Minimum Shelf Life',
  'tdcproperties.case_maximumshelflife': 'Case Maximum Shelf Life',
  'tdcproperties.case_minimumtransporttemp': 'Case Minimum Transport Temp',
  'tdcproperties.case_maximumtransporttemp': 'Case Maximum Transport Temp',
  'tdcproperties.case_minimumstoragehandlingtemp':
    'Case Minimum Storage/Handling Temp',
  'tdcproperties.case_maximumstoragehandlingtemp':
    'Case Maximum Storage/Handling Temp',
  'tdcproperties.case_tie': 'Case Tie',
  'tdcproperties.case_high': 'Case High',
  'tdcproperties.innerpack_krogerclasscode': 'Inner-Pack Kroger Class Code',
  'tdcproperties.innerpack_minimumshelflife': 'Inner-Pack Minimum Shelf Life',
  'tdcproperties.innerpack_maximumshelflife': 'Inner-Pack Maximum Shelf Life',
  'tdcproperties.innerpack_minimumtransporttemp':
    'Inner-Pack Minimum Transport Temp',
  'tdcproperties.innerpack_maximumtransporttemp':
    'Inner-Pack Maximum Transport Temp',
  'tdcproperties.innerpack_minimumstoragehandlingtemp':
    'Inner-Pack Minimum Storage/Handling Temp',
  'tdcproperties.innerpack_maximumstoragehandlingtemp':
    'Inner-Pack Maximum Storage/Handling Temp',
  'tdcproperties.innerpack_tie': 'Inner-Pack Tie',
  'tdcproperties.innerpack_high': 'Inner-Pack High',
  'tdcproperties.nutpanel_indicators': 'Nutrition Panel Indicators',
  'tdcproperties.nutpanel_indicatorsforamount':
    'Nutrition Panel Indicators For Amount',
  'tdcproperties.suppanel_indicators': 'Supplement Panel Indicators',
  'tdcproperties.suppanel_indicatorsforamount':
    'Supplement Panel Indicators For Amount',
  'tdcproperties.aminopanel_essential': 'Amino Acid Panel Essential',
  'tdcproperties.aminopanel_onescoop': 'Amino Acid Panel One Scoop',
  'tdcproperties.aminopanel_twoscoop': 'Amino Acid Panel Two Scoop',
  'tdcproperties.aminopanel_indicators': 'Amino Acid Panel Indicators',
};

export const BASE_MODULE = {
  dateadded: 'Date Added',
  datecaptured: 'Date Captured',
  drainedweight: 'Drained Weight',
  drainedweightuom: 'Drained Weight Unit of Measure',
  esymbolpresent: 'e Symbol Present',
  imperialsize: 'Imperial Size',
  imperialuom: 'Imperial UOM',
  inproduction: 'Product - In Production',
  ismultipack: 'Multi-Pack/Shipper',
  manufacturernameheader: 'Manufacturer Name',
  metricsize: 'Metric Size',
  metricuom: 'Metric UOM',
  productflavor: 'Product Flavor',
  productscent: 'Product Scent',
  productstyle: 'Product Style',
  secondarydrainedweight: 'Secondary Drained Weight',
  secondarydrainedweightuom: 'Secondary Drained Weight UOM',
  secondaryproductdescription: 'Product Flavor or Type',
  secondarysize: 'Secondary Size',
  secondarysizeuom: 'Secondary Size Unit of Measure',
  servingsuggestionpresent: 'Serving Suggestion Present',
  tertiarydescription: 'Further Product Description',
  tertiarysize: 'Tertiary Size',
  tertiarysizeuom: 'Tertiary Size Unit of Measure',
  unitcount: 'Unit Count',
  vendoritemnumber: 'Vendor Item #',
  adasealofacceptance:
    'ADA Seal of Acceptance - American Dental Association Certifier',
  authenticmadeproducedbyamericanindianscertifier:
    'Authentic Made / Produced By American Indians Certifier',
  beebettercertifier: 'Bee Friendly Certifier',
  biobasedcertifier: 'Bio-Based Certifier',
  biodynamiccertifier: 'Bio-Dynamic Certifier',
  businessownermanufacturercertifier: 'Business Owner / Manufacturer Certifier',
  carbonfootprintcertifier: 'Carbon Footprint Certifier',
  cbdhempcertifier: 'CBD / Hemp Certifier',
  certificationsancillary: 'Ancillary Certifiers',
  certifiedauthenticmadeproducedbyamericanindians:
    'Authentic Made / Produced By American Indians Claim',
  certifiedbcorporation: 'Certified B Corporation',
  coldpressuredprotectedclaim: 'Cold Pressured Protected Claim',
  coldpressureverified: 'Cold Pressure Verified',
  cradletocradlecertifier: 'Cradle To Cradle Certifier',
  crueltyfreecertifier: 'Cruelty Free Certifier',
  diabeticfriendlycertifier: 'Diabetic Friendly Certifier',
  ecofisherycertification: 'Eco Fishery Certifier',
  fairtradecertifier: 'Fair Trade Certifier',
  forlifecertifier: 'For Life Certifier',
  gdsnprovidedcertifications: 'GDSN Provided Certifications',
  glutenfreecertifier: 'Gluten-Free Certifier',
  glycemicindexcertifier: 'Glycemic Index Certifier',
  glyphosateintransition: 'Glyphosate In Transition',
  glyphosateintransitionclaim: 'Glyphosate Residue In Transition',
  glyphosateresiduefree: 'Glyphosate Residue Free',
  gmpcertifier: 'GMP Certifier',
  grassfedcertifier: 'Grass-Fed Certifier',
  halalcertifier: 'Halal Certifier',
  hearthealthycertifier: 'Heart Healthy Certifier',
  highpressurecertifiedcertifier: 'High Pressure Certified Certifier',
  highpressurecoldpressurecoldpressuredstatement:
    'High Pressure / Cold Pressure / Cold Pressured Statement',
  internationalpackagediceassociation:
    'Certified by International Packaged Ice Association',
  italcertifiedsealcertifier: 'ITAL CERTIFIED SEAL Certifier',
  italconscioussealcertifier: 'ITAL CONSCIOUS SEAL Certifier',
  italsacramentsealcertifier: 'ITAL SACRAMENT SEAL Certifier',
  ketocertifier: 'Keto/Ketogenic Certifier',
  koshercertification: 'Kosher Certifier',
  koshertype: 'Kosher Type',
  liveandactiveculturecertifier:
    'Live and Active Cultures Certified by the National Yogurt Association',
  lowglycemiccertifier: 'Low-Glycemic Certifier',
  naturalpersonalcarecertifier: 'Natural Personal Care Certifier',
  newyorkstategrowncertifier: 'New York State Grown Certifier',
  nongmocertifier: 'Non-GMO Certifier',
  npacertifier: 'NPA Certifier',
  nutrasouceigenprogram: 'Nutrasouce IGEN Program ',
  onepercentfortheplanetcertifier: '1% For The Planet Certifier',
  organiccertifyingbody: 'Organic Certifying Body',
  organicpercentage: 'Organic Percentage',
  organicpercentagetext: 'Organic Percentage Text',
  organicstandardsagency: 'Organic Standards Agency',
  organicstandardsagencylogo: 'Organic Standards Agency Logo',
  pacacertifier: 'PACA Certifier',
  paleocertifier: 'Paleo Certifier',
  pasacertifier: 'PASA Certifier',
  plantbasedderivedcertifier: 'Plant Based/Derived Certifier',
  rainforestalliancecertifier: 'Rain Forest Alliance Certifier',
  realcertified:
    'REAL Certified - Responsible Epicurean and Agricultural Leadership Certifier',
  realsealcertifier: 'Real Seal Certifier',
  regenerativeorganiccertifier: 'Regenerative Organic Certifier',
  renewableenergycertifier: 'Renewable Energy Certifier',
  sustainabilitycertifier: 'Sustainability Certifier',
  sustainablefisheriespartnership_sfp:
    'Sustainable Fisheries Partnership (SFP)',
  vegancertifier: 'Vegan Certifier',
  vegetariancertifier: 'Vegetarian Certifier',
  veteranscertifier: 'Veterans Certification',
  viticulturecertifier: 'Viticulture Certifiers',
  waterqualityassociationcertifier: 'Water Quality Association Certifier',
  wholegraincertifier: 'Whole Grain Certifier',
  womensbusinessenterprisenationalcouncilcertifier:
    'Womens Business Enterprise National Council Certifier',
  notforretailsale: 'Not For Retail Sale',
  sellablesplitdate: 'Sellable Split Date',
  discontinued: 'Discontinued',
};

export const ADVANCE_MODULE = {
  'alcoholinformation.alcoholinformation.alcoholbeveragecontainer.containertypecode':
    'Alcohol Information - Alcohol Beverage Container - Container Type Code',
  'alcoholinformation.alcoholinformation.alcoholbeveragecontainer.containershapecode':
    'Alcohol Information - Alcohol Beverage Container - Container Shape Code',
  'alcoholinformation.alcoholinformation.alcoholbeveragecontainer.containermaterialcode':
    'Alcohol Information - Alcohol Beverage Container - Container Material Code',
  'alcoholinformation.alcoholinformation.alcoholicbeveragesubregion':
    'Alcohol Information - Alcoholic Beverage Subregion',
  'alcoholinformation.alcoholinformation.percentageofalcoholbyvolume':
    'Alcohol Information - Percentage Of Alcohol By Volume',
  'alcoholinformation.alcoholinformation.alcoholproof':
    'Alcohol Information - Alcohol Proof',
  'alcoholinformation.alcoholinformation.vintage':
    'Alcohol Information - Vintage',
  'alcoholinformation.alcoholinformation.alcoholbeveragetypecode':
    'Alcohol Information - Alcohol Beverage Type Code',
  'alcoholinformation.alcoholinformation.beerstylecode':
    'Alcohol Information - Beer Style Code',
  'alcoholinformation.alcoholinformation.alcoholbeveragedistilledfromcode':
    'Alcohol Information - Alcohol Beverage Distilled From Code',
  'alcoholinformation.alcoholinformation.alcoholbeverageage.value':
    'Alcohol Information - Alcohol Beverage Age - Value',
  'alcoholinformation.alcoholinformation.alcoholbeverageage.timemeasurementunitcode':
    'Alcohol Information - Alcohol Beverage Age - Time Measurement Unit Code',
  'allergeninformation.allergenrelatedinformation.allergenstatement.value':
    'Allergen Related Information - Allergen Statement - Value',
  'allergeninformation.allergenrelatedinformation.allergenspecificationagency':
    'Allergen Related Information - Allergen Specification Agency',
  'allergeninformation.allergenrelatedinformation.allergenspecificationname':
    'Allergen Related Information - Allergen Specification Name',
  'allergeninformation.allergenrelatedinformation.allergen.allergentypecode':
    'Allergen Related Information - Allergen - Allergen Type Code',
  'allergeninformation.allergenrelatedinformation.allergen.levelofcontainmentcode':
    'Allergen Related Information - Allergen - Level Of Containment Code',
  'allergeninformation.allergenrelatedinformation.allergen.containmentsource':
    'Allergen Related Information - Allergen - Containment Source',
  'consumerinstructions.consumerinstructions.consumerstorageinstructions.value':
    'Consumer Instructions - Consumer Storage Instructions - Value',
  'consumerinstructions.consumerinstructions.consumerstorageinstructions.languagecode':
    'Consumer Instructions - Consumer Storage Instructions - Language Code',
  'consumerinstructions.consumerinstructions.consumerusageinstructions.value':
    'Consumer Instructions - Consumer Usage Instructions - Value',
  'consumerinstructions.consumerinstructions.consumerusageinstructions.languagecode':
    'Consumer Instructions - Consumer Usage Instructions - Language Code',
  'deliverypurchasinginformation.deliverypurchasinginformation.distributiondetails.orderingleadtime.value':
    'Delivery Purchasing Information - Distribution Details - Ordering Lead Time - Value',
  'deliverypurchasinginformation.deliverypurchasinginformation.distributiondetails.orderingleadtime.measurementunitcode':
    'Delivery Purchasing Information - Distribution Details - Ordering Lead Time - Measurement Unit Code',
  'deliverypurchasinginformation.deliverypurchasinginformation.orderingunitofmeasure':
    'Delivery Purchasing Information - Ordering Unit Of Measure',
  'deliverypurchasinginformation.deliverypurchasinginformation.orderquantityminimum':
    'Delivery Purchasing Information - Order Quantity Minimum',
  'dietinformation.dietinformation.diettypeinformation.diettypecode':
    'Diet Information - Diet Type Information - Diet Type Code',
  'farmingandprocessinginformation.tradeitemfarmingandprocessing.growingmethodcode':
    'Trade Item Farming And Processing - Growing Method Code',
  'foodandbeverageingredient.ingredientstatement.value':
    'Ingredient Statement - Value',
  'foodandbeverageingredient.juicecontentpercent': 'Juice Content Percent',
  'foodandbeveragepreparationserving.servingquantityinformation.numberofservingsperpackage':
    'Serving Quantity Information - Number Of Servings Per Package',
  'foodandbeveragepreparationserving.servingquantityinformation.numberofservingsperpackagemeasurementprecisioncode':
    'Serving Quantity Information - Number Of Servings Per Package Measurement Precision Code',
  'foodandbeveragepreparationserving.preparationserving.preparationinstructions.value':
    'Preparation Serving - Preparation Instructions - Value',
  'foodandbeveragepreparationserving.preparationserving.recipe.value':
    'Preparation Serving - Recipe - Value',
  'foodandbeveragepreparationserving.preparationserving.recipe.languagecode':
    'Preparation Serving - Recipe - Language Code',
  'healthrelatedinformation.healthrelatedinformation.cannabiscbdtypecode':
    'Health Related Information - Cannabis CBD Type Code',
  'healthwellnesspackagingmarking.healthwellnesspackagingmarking.packagingmarkeddietallergencode':
    'Health Wellness Packaging Marking - Packaging Marked Diet Allergen Code',
  'marketinginformation.marketinginformation.marketingcampaign.tastingnotes.value':
    'Marketing Information - Marketing Campaign - Tasting Notes - Value',
  'marketinginformation.marketinginformation.marketingcampaign.tastingnotes.languagecode':
    'Marketing Information - Marketing Campaign - Tasting Notes - Language Code',
  'marketinginformation.marketinginformation.specialitemcode':
    'Marketing Information - Special Item Code',
  'marketinginformation.marketinginformation.tradeitemmarketingmessage.value':
    'Marketing Information - Trade Item Marketing Message - Value',
  'marketinginformation.marketinginformation.educationalfocusdescription.value':
    'Marketing Information - Educational Focus Description - Value',
  'marketinginformation.marketinginformation.educationalfocusdescription.languagecode':
    'Marketing Information - Educational Focus Description - Language Code',
  'organismclassification.organismclassification.species':
    'Organism Classification - Species',
  'packaginginformation.packaging.packagingmaterial.packagingmaterialtypecode':
    'Packaging - Packaging Material - Packaging Material Type Code',
  'packaginginformation.packaging.packagingrecyclingprocesstypecode':
    'Packaging - Packaging Recycling Process Type Code',
  'packaginginformation.packaging.packagingtypecode':
    'Packaging - Packaging Type Code',
  'packaginginformation.packaging.packagingtypedescription':
    'Packaging - Packaging Type Description',
  'packaginginformation.packaging.packagingtypedescription.value':
    'Packaging - Packaging Type Description - Value',
  'packaginginformation.packaging.packagingtypedescription.languagecode':
    'Packaging - Packaging Type Description - Language Code',
  'packagingmarking.packagingmarking.hasbatchnumber':
    'Packaging Marking - Has Batch Number',
  'packagingmarking.packagingmarking.ispackagingmarkedreturnable':
    'Packaging Marking - Is Packaging Marked Returnable',
  'packagingmarking.packagingmarking.ispriceonpack':
    'Packaging Marking - Is Price On Pack',
  'packagingmarking.packagingmarking.packagingmarkedlabelaccreditationcode':
    'Packaging Marking - Packaging Marked Label Accreditation Code',
  'packagingsustainability.lifecycleindicators.acidificationpotential.acidificationmeasurement.value':
    'Life Cycle Indicators - Acidification Potential - Acidification Measurement - Value',
  'packagingsustainability.lifecycleindicators.acidificationpotential.acidificationmeasurement.measurementunitcode':
    'Life Cycle Indicators - Acidification Potential - Acidification Measurement - Measurement Unit Code',
  'packagingsustainability.individualpackagingcomponentlevel.packagingrecovery.doespackagingrecoveryratetypecodemeetthestandard':
    'Individual Packaging Component Level - Packaging Recovery - Does Packaging Recovery Rate Type Code Meet The Standard',
  'packagingsustainability.individualpackagingcomponentlevel.packagingrecovery.packagingrecoveryratetypecode':
    'Individual Packaging Component Level - Packaging Recovery - Packaging Recovery Rate Type Code',
  'packagingsustainability.individualpackagingcomponentlevel.packagingrecycledcontent.packagingrecycledcontentdescription.value':
    'Individual Packaging Component Level - Packaging Recycled Content - Packaging Recycled Content Description - Value',
  'packagingsustainability.individualpackagingcomponentlevel.packagingrecycledcontent.packagingrecycledcontentdescription.languagecode':
    'Individual Packaging Component Level - Packaging Recycled Content - Packaging Recycled Content Description - Language Code',
  'placeofitemactivity.importclassification.importclassificationtypecode':
    'Import Classification - Import Classification Type Code',
  'placeofitemactivity.importclassification.importclassificationvalue':
    'Import Classification - Import Classification Value',
  'placeofitemactivity.placeofproductactivity.countryoforigin.countrycode':
    'Place Of Product Activity - Country Of Origin - Country Code',
  'placeofitemactivity.placeofproductactivity.countryoforigin.countrysubdivisioncode':
    'Place Of Product Activity - Country Of Origin - Country Subdivision Code',
  'placeofitemactivity.placeofproductactivity.countryoforiginstatement.value':
    'Place Of Product Activity - Country Of Origin Statement - Value',
  'placeofitemactivity.placeofproductactivity.countryoforiginstatement.languagecode':
    'Place Of Product Activity - Country Of Origin Statement - Language Code',
  'salesinformation.salesinformation.targetmarketsalesconditions.salesconditiontargetmarketcountry.countrycode':
    'Sales Information - Target Market Sales Conditions - Sales Condition Target Market Country - Country Code',
  'tradeitemdatacarrierandidentification.datacarrier.datacarrierfamilytypecode':
    'Data Carrier - Data Carrier Family Type Code',
  'tradeitemdatacarrierandidentification.datacarrier.datacarriertypecode':
    'Data Carrier - Data Carrier Type Code',
  'tradeitemdatacarrierandidentification.gs1tradeitemidentificationkey.gs1tradeitemidentificationkeycode':
    'GS1 Trade Item Identification Key - GS1 Trade Item Identification Key Code',
  'tradeitemdatacarrierandidentification.gs1tradeitemidentificationkey.gs1tradeitemidentificationkeyvalue':
    'GS1 Trade Item Identification Key - GS1 Trade Item Identification Key Value',
  'tradeitemdescription.tradeitemdescriptioninformation.brandnameinformation.brandname':
    'Trade Item Description Information - Brand Name Information - Brand Name',
  'tradeitemdescription.tradeitemdescriptioninformation.brandnameinformation.languagespecificbrandname.value':
    'Trade Item Description Information - Brand Name Information - Language Specific Brand Name - Value',
  'tradeitemdescription.tradeitemdescriptioninformation.brandnameinformation.languagespecificbrandname.languagecode':
    'Trade Item Description Information - Brand Name Information - Language Specific Brand Name - Language Code',
  'tradeitemdescription.tradeitemdescriptioninformation.additionaltradeitemdescription.value':
    'Trade Item Description Information - Additional Trade Item Description - Value',
  'tradeitemdescription.tradeitemdescriptioninformation.descriptionshort.value':
    'Trade Item Description Information - Description Short - Value',
  'tradeitemdescription.tradeitemdescriptioninformation.functionalname.value':
    'Trade Item Description Information - Functional Name - Value',
  'tradeitemdescription.tradeitemdescriptioninformation.functionalname.languagecode':
    'Trade Item Description Information - Functional Name - Language Code',
  'tradeitemdescription.tradeitemdescriptioninformation.tradeitemdescription.value':
    'Trade Item Description Information - Trade Item Description - Value',
  'tradeitemdescription.tradeitemdescriptioninformation.tradeitemdescription.languagecode':
    'Trade Item Description Information - Trade Item Description - Language Code',
  'tradeitemhandling.tradeitemhandlinginformation.handlinginstructionsdescription.value':
    'Trade Item Handling Information - Handling Instructions Description - Value',
  'tradeitemlifespan.tradeitemlifespan.minimumtradeitemlifespanfromtimeofarrival':
    'Trade Item Lifespan - Minimum Trade Item Lifespan From Time Of Arrival',
  'tradeitemlifespan.tradeitemlifespan.minimumtradeitemlifespanfromtimeofproduction':
    'Trade Item Lifespan - Minimum Trade Item Lifespan From Time Of Production',
  'tradeitemmeasurements.tradeitemmeasurements.tradeitemweight.grossweight.value':
    'Trade Item Measurements - Trade Item Weight - Gross Weight - Value',
  'tradeitemmeasurements.tradeitemmeasurements.tradeitemweight.grossweight.measurementunitcode':
    'Trade Item Measurements - Trade Item Weight - Gross Weight - Measurement Unit Code',
  'tradeitemmeasurements.tradeitemmeasurements.depth.value':
    'Trade Item Measurements - Depth - Value',
  'tradeitemmeasurements.tradeitemmeasurements.depth.measurementunitcode':
    'Trade Item Measurements - Depth - Measurement Unit Code',
  'tradeitemmeasurements.tradeitemmeasurements.height.value':
    'Trade Item Measurements - Height - Value',
  'tradeitemmeasurements.tradeitemmeasurements.height.measurementunitcode':
    'Trade Item Measurements - Height - Measurement Unit Code',
  'tradeitemmeasurements.tradeitemmeasurements.inboxcubedimension.value':
    'Trade Item Measurements - In Box Cube Dimension - Value',
  'tradeitemmeasurements.tradeitemmeasurements.inboxcubedimension.measurementunitcode':
    'Trade Item Measurements - In Box Cube Dimension - Measurement Unit Code',
  'tradeitemmeasurements.tradeitemmeasurements.netcontent.value':
    'Trade Item Measurements - Net Content - Value',
  'tradeitemmeasurements.tradeitemmeasurements.netcontent.measurementunitcode':
    'Trade Item Measurements - Net Content - Measurement Unit Code',
  'tradeitemmeasurements.tradeitemmeasurements.width.value':
    'Trade Item Measurements - Width - Value',
  'tradeitemmeasurements.tradeitemmeasurements.width.measurementunitcode':
    'Trade Item Measurements - Width - Measurement Unit Code',
  'tradeitemmeasurements.tradeitemmeasurements.netcontentstatement.value':
    'Trade Item Measurements - Net Content Statement - Value',
  'tradeitemmeasurements.tradeitemmeasurements.netcontentstatement.languagecode':
    'Trade Item Measurements - Net Content Statement - Language Code',
  'tradeitemtemperatureinformation.tradeitemtemperatureconditiontypecode':
    'Trade Item Temperature Condition Type Code',
  'tradeitemhierarchy.tradeitemhierarchy.quantityoflayersperpallet':
    'Trade Item Hierarchy - Quantity Of Layers Per Pallet',
  'tradeitemhierarchy.tradeitemhierarchy.quantityoftradeitemsperpalletlayer':
    'Trade Item Hierarchy - Quantity Of Trade Items Per Pallet Layer',
};
export const BASIC_FIELD = {
  gtin: 'GTIN',
  producttype: 'Product Type',
  brickcode: 'Brick Code',
  brickcodename: 'Brick Code Name',
  ixoneid: 'IX One ID',
  primarysize: 'Primary Size',
  primarysizeuom: 'Primary Size UOM',
  productname: 'Product Name',
  depth: 'Depth',
  height: 'Height',
  upc10: 'UPC10',
  upc11: 'UPC11',
  upc12: 'UPC12',
  upc13: 'UPC13',
  upc8: 'UPC8',
  weight: 'Weight',
  width: 'Width',
  targetmarket: 'Target Market',
  packagelevel: 'Package Level',
};

export const PRODUCT_SPEC = {
  codedatestamp: 'codeDateStamp',
  codedatetype: 'codeDateType',
  codedateformula: 'codeDateFormula',
  codedateexample: 'codeDateExample',
  gmostatement: 'gmoStatement',
  nongmostatement: 'nonGmoStatement',
  bioengineeredstatement: 'bioengineeredStatement',
  productcontainsbioengineeredingredients:
    'productContainsBioengineeredIngredients',
  rbghbststatement: 'rbghBstStatement',
  californiaprop65warningstatement: 'californiaProp65WarningStatement',
  fairtradestatement: 'fairTradeStatement',
  usdastatement: 'usdaStatement',
  minimumshelflife: 'minimumShelfLife',
  maximumshelflife: 'maximumShelfLife',
  shelflifeafteropening: 'shelfLifeAfterOpening',
  casetemperaturerangehigh: 'caseTemperatureRangeHigh',
  casetemperaturerangelow: 'caseTemperatureRangeLow',
  caseshippingtemperaturehigh: 'caseShippingTemperatureHigh',
  caseshippingtemperaturelow: 'caseShippingTemperatureLow',
  countryoforigin: 'countryOfOrigin',
  targetmarket: 'targetMarket',
  halalyn: 'halalYN',
  kosheryn: 'kosherYN',
  koshercertifier: 'kosherCertifier',
  halalcertifier: 'halalCertifier',
  nongmoyn: 'nonGMOYN',
  nongmocertifier: 'nonGMOCertifier',
  organicyn: 'organicYN',
  organiccertifier: 'organicCertifier',
  isocertifier: 'isoCertifier',
  ifscertifier: 'ifsCertifier',
  brccertifier: 'brcCertifier',
};

export const LABELING = {
  upc12: 'UPC12',
  secondarydescriptor: 'secondary Descriptor',
  tertiarydescriptor: 'Tertiary Descriptor',
  size: 'Size',
  uom: 'UOM',
  ingredientstatement: 'Ingredient Statement',
  // allergenstatement: 'Allergen Statement',
  vegetablebasedink: 'Vegetable Based Ink',
  recycledmaterial: 'Made With Recycled Material',
  soyink: 'Soy Ink',
  storageinstructions: 'Storage Instructions',
  handlinginstructions: 'Handling Instructions',
  usage: 'Usage',
  cookinginstructions: 'Cooking Instructions',
  recipe: 'Recipe',
  bioengineeredstatement: 'Bioengineered Statement',
  warningstatement: 'Warning Statement',
  recyclabletypes: 'Recyclable Types',
  packagingtype: 'Packaging Type',
  packagingmaterial: 'Packaging Material',
  qrcode: 'QR Code',
  halalyn: 'Halal',
  kosheryn: 'Kosher',
  koshercertifier: 'Kosher Certifier',
  halalcertifier: 'Halal Certifier',
  nongmoyn: 'Non-GMO',
  nongmocertifier: 'Non-GMO Certifier',
  organicyn: 'Organic',
  organiccertifier: 'Organic Certifier',
  isocertifier: 'ISO Certifier',
  ifscertifier: 'IFS Certifier',
  brccertifier: 'BRC Certifier',
};

export const CLAIMS = {
  onepercentfortheplanetclaim: 'onePercentForThePlanetClaim',
  adasealofacceptanceclaim: 'adaSealofAcceptanceClaim',
  beebetterclaim: 'beeBetterClaim',
  biobasedyn: 'bioBasedYN',
  biodegradable: 'biodegradable',
  productisbiodegradable: 'productIsBiodegradable',
  biodynamicyn: 'bioDynamicYN',
  bioengineeredyn: 'bioengineeredYN',
  containsbpa: 'containsBPA',
  bpafreeliner: 'bpaFreeLiner',
  bpafreepackaging: 'bpaFreePackaging',
  carbonfootprintyn: 'carbonFootprintYN',
  cradletocradleyn: 'cradleToCradleYN',
  crueltyfreeyn: 'crueltyFreeYN',
  diabeticfriendlyyn: 'diabeticFriendlyYN',
  dolphinfriendly: 'dolphinFriendly',
  ecofisheryyn: 'ecoFisheryYN',
  fairtradeyn: 'fairTradeYN',
  forlifeyn: 'forLifeYN',
  glyphosateresiduefreeclaim: 'glyphosateResidueFreeClaim',
  gmpyn: 'gmpyn',
  grassfedyn: 'grassFedYN',
  hearthealthyyn: 'heartHealthyYN',
  highpotency: 'highPotency',
  highpressurecertifiedclaim: 'highPressureCertifiedClaim',
  ingredientschina: 'ingredientsChina',
  italcertifiedsealclaim: 'italCertifiedSealClaim',
  italconscioussealclaim: 'italConsciousSealClaim',
  italsacramentsealclaim: 'italSacramentSealClaim',
  ketoyn: 'ketoYN',
  liveandactiveculture: 'liveAndActiveCulture',
  lowglycemicyn: 'lowGlycemicYN',
  organicingredientsmadewith: 'organicIngredientsMadeWith',
  nonirradiatedingredients: 'nonIrradiatedIngredients',
  npayn: 'npayn',
  pacayn: 'pacayn',
  paleoyn: 'paleoYN',
  pasayn: 'pasayn',
  plantbasedderivedclaim: 'plantBasedDerivedClaim',
  rainforestallianceyn: 'rainForestAllianceYN',
  realcertifiedclaim: 'realCertifiedClaim',
  contains: 'contains',
  doesnotcontain: 'doesNotContain',
};

export const PET_FOOD = {
  warnings: 'warnings',
  usageinstructions: 'usageInstructions',
};

export const FRESH_SEAFOOD = {
  safehandlinginstructions: 'safeHandlingInstructions',
};

export const FACT_PANEL = {
  'petnutritionfacts.nutrientformattype':
    'petnutritionfacts.nutrientformattype',
  'petnutritionfacts.measurementpercup': 'petnutritionfacts.measurementpercup',
  'petnutritionfacts.measurementuompercup':
    'petnutritionfacts.measurementuompercup',
  'petnutritionfacts.caloriespercup': 'petnutritionfacts.caloriespercup',
  'petnutritionfacts.protein': 'petnutritionfacts.protein',
  'petnutritionfacts.fat': 'petnutritionfacts.fat',
  'petnutritionfacts.carbohydrate': 'petnutritionfacts.carbohydrate',
  'petnutritionfacts.caloriecontent': 'petnutritionfacts.caloriecontent',
  'petnutritionfacts.enzymesandmicroorganisms':
    'petnutritionfacts.enzymesandmicroorganisms',
  'petnutritionfacts.nutritionaladequacystatement':
    'petnutritionfacts.nutritionaladequacystatement',
  'petnutritionfacts.fdalabelfootnote': 'petnutritionfacts.fdalabelfootnote',
  'petnutritionfacts.nutrients.nutrientname':
    'petnutritionfacts.nutrients.nutrientname',
  'petnutritionfacts.nutrients.limit': 'petnutritionfacts.nutrients.limit',
  'petnutritionfacts.nutrients.guaranteed':
    'petnutritionfacts.nutrients.guaranteed',
  'petnutritionfacts.nutrients.guaranteeduom':
    'petnutritionfacts.nutrients.guaranteeduom',
  'petnutritionfacts.nutrients.quantity':
    'petnutritionfacts.nutrients.quantity',
  'petnutritionfacts.nutrients.quantityuom':
    'petnutritionfacts.nutrients.quantityuom',
  'supplementfacts.id': 'supplementfacts.id',
  'supplementfacts.nutrientformattype': 'supplementfacts.nutrientformattype',
  'supplementfacts.servingsize': 'supplementfacts.servingsize',
  'supplementfacts.servingsizemeasurement':
    'supplementfacts.servingsizemeasurement',
  'supplementfacts.servingsizedescription':
    'supplementfacts.servingsizedescription',
  'supplementfacts.numberofservingspercontainer':
    'supplementfacts.numberofservingspercontainer',
  'supplementfacts.calories': 'supplementfacts.calories',
  'supplementfacts.caloriesfromfat': 'supplementfacts.caloriesfromfat',
  'supplementfacts.fdalabelfootnote': 'supplementfacts.fdalabelfootnote',
  'supplementfacts.otheringredients': 'supplementfacts.otheringredients',
  'supplementfacts.languagecode': 'supplementfacts.languagecode',
  // 'supplementfacts.servingpercontainerdescriptor':
  // 'supplementfacts.servingpercontainerdescriptor',
  'supplementfacts.nutrients.nutritionname':
    'supplementfacts.nutrients.nutritionname',
  'supplementfacts.nutrients.italicnutrient':
    'supplementfacts.nutrients.italicnutrient',
  'supplementfacts.nutrients.descriptor':
    'supplementfacts.nutrients.descriptor',
  'supplementfacts.nutrients.italicdescriptor':
    'supplementfacts.nutrients.italicdescriptor',
  'supplementfacts.nutrients.ingredientspartof':
    'supplementfacts.nutrients.ingredientspartof',
  'supplementfacts.nutrients.quantity': 'supplementfacts.nutrients.quantity',
  'supplementfacts.nutrients.quantityuom':
    'supplementfacts.nutrients.quantityuom',
  'supplementfacts.nutrients.quantitydescription':
    'supplementfacts.nutrients.quantitydescription',
  'supplementfacts.nutrients.dailyvalue':
    'supplementfacts.nutrients.dailyvalue',
  'supplementfacts.nutrients.dailysymbol':
    'supplementfacts.nutrients.dailysymbol',
  'supplementfacts.dietaryingredients.ingredientname':
    'supplementfacts.dietaryingredients.ingredientname',
  'supplementfacts.dietaryingredients.italicdietary':
    'supplementfacts.dietaryingredients.italicdietary',
  'supplementfacts.dietaryingredients.descriptor':
    'supplementfacts.dietaryingredients.descriptor',
  'supplementfacts.dietaryingredients.italicdescriptor':
    'supplementfacts.dietaryingredients.italicdescriptor',
  'supplementfacts.dietaryingredients.ingredientspartof':
    'supplementfacts.dietaryingredients.ingredientspartof',
  'supplementfacts.dietaryingredients.quantity':
    'supplementfacts.dietaryingredients.quantity',
  'supplementfacts.dietaryingredients.quantityuom':
    'supplementfacts.dietaryingredients.quantityuom',
  'supplementfacts.dietaryingredients.quantitydescription':
    'supplementfacts.dietaryingredients.quantitydescription',
  'supplementfacts.dietaryingredients.dailysymbol':
    'supplementfacts.dietaryingredients.dailysymbol',
  'nutritionfacts.id': 'nutritionfacts.id',
  'nutritionfacts.nutrientformattype': 'nutritionfacts.nutrientformattype',
  'nutritionfacts.numberofservingsperpackage':
    'nutritionfacts.numberofservingsperpackage',
  'nutritionfacts.servingpercontainerdescriptor':
    'nutritionfacts.servingpercontainerdescriptor',
  'nutritionfacts.servingsize': 'nutritionfacts.servingsize',
  'nutritionfacts.servingsizemeasurement':
    'nutritionfacts.servingsizemeasurement',
  'nutritionfacts.servingsizedescription':
    'nutritionfacts.servingsizedescription',
  'nutritionfacts.calories': 'nutritionfacts.calories',
  // 'nutritionfacts.ingredientnotice': 'nutritionfacts.ingredientnotice',
  'nutritionfacts.fdalabelfootnote': 'nutritionfacts.fdalabelfootnote',
  // 'nutritionfacts.nutrientbasisquantitytypecode':
  // 'nutritionfacts.nutrientbasisquantitytypecode',
  'nutritionfacts.nutrientbasisvalue': 'nutritionfacts.nutrientbasisvalue',
  // 'nutritionfacts.unitofmeasure': 'nutritionfacts.unitofmeasure',
  'nutritionfacts.languagecode': 'nutritionfacts.languagecode',
  'nutritionfacts.nutritionfactproperties.id':
    'nutritionfacts.nutritionfactproperties.id',
  'nutritionfacts.nutritionfactproperties.nutritiontypecode':
    'nutritionfacts.nutritionfactproperties.nutritiontypecode',
  'nutritionfacts.nutritionfactproperties.measurementprecisioncode':
    'nutritionfacts.nutritionfactproperties.measurementprecisioncode',
  'nutritionfacts.nutritionfactproperties.nutritionname':
    'nutritionfacts.nutritionfactproperties.nutritionname',
  'nutritionfacts.nutritionfactproperties.dailyvalueintakepercent':
    'nutritionfacts.nutritionfactproperties.dailyvalueintakepercent',
  'nutritionfacts.nutritionfactproperties.quantity':
    'nutritionfacts.nutritionfactproperties.quantity',
  'nutritionfacts.nutritionfactproperties.quantityuom':
    'nutritionfacts.nutritionfactproperties.quantityuom',
  'nutritionfacts.nutritionfactproperties.nutritionindicator':
    'nutritionfacts.nutritionfactproperties.nutritionindicator',
};

export const NUTRITION = {
  nutrientformattype: 'Label Type',
  numberofservingsperpackage: 'Servings Per Container',
  // servingpercontainerdescriptor: 'Servings Per Container Descriptor',
  servingsize: 'Size',
  servingsizemeasurement: 'Size Unit',
  servingsizedescription: 'Description',
  calories: 'Calories',
  // ingredientnotice: 'Ingredient Notice',
  fdaLabelfootnote: 'Footer Note',
  factsPaneltype: 'Type',
  // nutrientbasisquantitytypecode: 'Nutrient Basis Quantity Type Code',
  // nutrientbasisvalue: 'Nutrient Basis',
  // unitofmeasure: 'Unit of Measure',
  'nutritionfactproperties.nutritiontypecode': 'Nutrients - Nutrient Type Code',
  'nutritionfactproperties.measurementprecisioncode':
    'Nutrients - Nutrient Measurement Precisioncode',
  'nutritionfactproperties.dailyvalueintakepercent':
    'Nutrients - Nutrient Daily Value',
  'nutritionfactproperties.quantity': 'Nutrients - Nutrient Quantity',
  'nutritionfactproperties.quantityUom': 'Nutrients - Nutrient Quantity UOM',
  languagecode: 'Language Code',
};

export const SUPPLEMENT = {
  nutrientformattype: 'Label Type',
  servingsize: 'Serving Size - Value',
  servingsizemeasurement: 'Serving Size - Unit of Measure',
  servingsizedescription: 'Serving Size - Description',
  numberofservingspercontainer: 'Servings Per Container',
  // servingPercontainerdescriptor: 'Servings Per Container Descriptor',
  calories: 'Calories',
  caloriesfromfat: 'Calories from Fat',
  fdalabelfootnote: 'Footer Note',
  otheringredients: 'Ingredient Notice',
  languagecode: 'Language Code',
  'nutrients.nutritionname': 'Nutrients - Nutrient Name',
  'nutrients.ingredientspartof': 'Nutrients - Part Of',
  'nutrients.descriptor': 'Nutrients - Descriptor',
  'nutrients.quantity': 'Nutrients - Quantity',
  'nutrients.quantityuom': 'Nutrients - Quantity UOM',
  'nutrients.quantitydescription': 'Nutrients - Quantity Description',
  'nutrients.dailyvalue': 'Nutrients - Daily Value',
  'nutrients.dailysymbol': 'Nutrients - Daily Symbol',
  'nutrients.italicnutrient': 'Nutrients - Italic Name',
  'nutrients.italicdescriptor': 'Nutrients - Italic Descriptor',
  'dietaryingredients.ingredientname': 'Dietary Ingredients - Ingredient Name',
  'dietaryingredients.ingredientspartof': 'Dietary Ingredients - Part Of',
  'dietaryingredients.descriptor': 'Dietary Ingredients - Descriptor',
  'dietaryingredients.quantity': 'Dietary Ingredients - Quantity',
  'dietaryingredients.quantityuom': 'Dietary Ingredients - Quantity UOM',
  'dietaryingredients.quantitydescription':
    'Dietary Ingredients - Quantity Description',
  'dietaryingredients.dailysymbol': 'Dietary Ingredients - Daily Symbol',
  'dietaryingredients.italicdietary': 'Dietary Ingredients - Italic Name',
  'dietaryingredients.italicdescriptor':
    'Dietary Ingredients - Italic Descriptor',
};

export const PET_NUTRITION = {
  nutrientformattype: 'Label Type',
  measurementpercup: 'Per Cup Measurement',
  measurementUompercup: 'Per Cup Measurement Unit',
  caloriecontent: 'Calories Content',
  caloriespercup: 'Calories Per Cup',
  protein: 'From Protein',
  fat: 'From Fat',
  carbohydrate: 'From Carbohydrate',
  'nutrients.nutrientname': 'Nutrients - Nutrient Name',
  'nutrients.limit': 'Nutrients - Measurement Limit',
  'nutrients.guaranteed': 'Nutrients - Guaranteed',
  'nutrients.guaranteeduom': 'Nutrients - Guaranteed UOM',
  'nutrients.quantity': 'Nutrients - Quantity',
  'nutrients.quantityuom': 'Nutrients - Quantity UOM',
  fdalabelfootnote: 'Footer Note',
  enzymesandmicroorganisms: 'Enzymes And Microorganisms',
  nutritionaladequacystatement: 'Nutritional Adequacy Statement',
};
